import React, { SVGProps } from 'react'

import { ISvg } from '~/shared/types/commonTypes'

interface IProps extends SVGProps<SVGSVGElement> {
  svg: ISvg
}

export const SvgImage: React.FC<IProps> = ({ svg, ...props }) => (
  <svg viewBox={svg.viewBox} {...props}>
    <use href={`#${svg.id}`} xlinkHref={`#${svg.id}`} />
  </svg>
)
